import { render } from "./productChannelManage.vue?vue&type=template&id=23ff99a8&scoped=true"
import script from "./productChannelManage.vue?vue&type=script&lang=js"
export * from "./productChannelManage.vue?vue&type=script&lang=js"

import "./productChannelManage.vue?vue&type=style&index=0&id=23ff99a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ff99a8"],['__file',"src/views/product/components/productChannelManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23ff99a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23ff99a8', __exports__)) {
    api.reload('23ff99a8', __exports__)
  }
  
  module.hot.accept("./productChannelManage.vue?vue&type=template&id=23ff99a8&scoped=true", () => {
    api.rerender('23ff99a8', render)
  })

}


export default __exports__